import { setTooManyRequestsCooldown } from "../actions/disablingProcessesActions";
import { TOO_MANY_REQUESTS_BLOCKING_WAITING_TIME_S } from "./constants/otherConstants";
import { saveTooManyRequestsBlocking } from "./localStorageUtils";

export const manageTooManyRequestsResponse = (response, dispatch) => {
    if(response.status !== 429) return;

    saveTooManyRequestsBlocking(true);
    dispatch(setTooManyRequestsCooldown(TOO_MANY_REQUESTS_BLOCKING_WAITING_TIME_S));
}